













import { Component, Mixins } from 'vue-property-decorator';
import { ListingFilter, ListingOrderBy } from 'client-website-ts-library/filters';
import { View } from 'client-website-ts-library/plugins';
import { ListingCategory } from 'client-website-ts-library/types';

import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';

@Component({
  components: {
    Listings,
    ListingSearch,
  },
})
export default class CommercialForSale extends Mixins(View) {
  private listingFilter: ListingFilter | null = null;

  handleFilter(filter: ListingFilter) {
    // eslint-disable-next-line no-param-reassign
    filter.Categories = [ListingCategory.Commercial, ListingCategory.CommercialLand];
    // eslint-disable-next-line no-param-reassign
    filter.OrderByStatements = [ListingOrderBy.CreateDateDesc];
    this.listingFilter = filter;
  }
}
